import { render, staticRenderFns } from "./ShippingTrackingModal.vue?vue&type=template&id=51188da7&scoped=true&"
import script from "./ShippingTrackingModal.vue?vue&type=script&lang=js&"
export * from "./ShippingTrackingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51188da7",
  null
  
)

export default component.exports